import AOS from 'aos'
import Parallax from 'parallax-js'
import VanillaTilt from "vanilla-tilt"
import { Loader } from "@googlemaps/js-api-loader"
import MarkerClusterer from '@googlemaps/markerclustererplus';
import SmoothScroll from 'smooth-scroll'

window.addEventListener('DOMContentLoaded',()=>{

    function firstScreenAnimation() {
        const title = document.querySelector('.main-header__title');
        const nav = document.querySelector('.main-header__nav');

        if(window.innerWidth < 601) {

            removeAOSAnimation( title );
            removeAOSAnimation( nav );

            setTimeout(function (){

                title.style.opacity = 1;
                nav.style.opacity = 1;

            }, 500)

        }

    }


    function removeAOSAnimation(elem) {

        elem.removeAttribute("data-aos");

    }

    firstScreenAnimation();



    //Инициализация библиотеки с анимациями по скроллу

    window.addEventListener('load', () => {

        AOS.init({
            duration:900,
            startEvent: 'DOMContentLoaded',
            once: true,
        });

    })





    //Бургер-меню
    let burgerButton = document.querySelector('.header__burger-button')
    let HtmlElem =  document.querySelector("html");
    let burgerMenu = document.querySelector('.burger')

    burgerButton.addEventListener('click',()=>{
        if (!burgerButton.classList.contains('show')){
            burgerButton.classList.add('show')
            burgerMenu.classList.add('show')
            HtmlElem.classList.add('menu__open')
        }
        else{
            burgerButton.classList.remove('show')
            burgerMenu.classList.remove('show')
            HtmlElem.classList.remove('menu__open')
        }
    })

    //Модальное окно с формой
    let reviewButton = document.querySelector('.review-slider__link')
    let modalReview = document.querySelector('.modal__review')
    let reviewClose = document.querySelector('.modal-review__close')
    if (reviewButton !== null){
        reviewButton.addEventListener('click',(e)=>{
            e.preventDefault()
            modalReview.classList.add('show')
            HtmlElem.classList.add('menu__open')
        })

        reviewClose.addEventListener('click',()=>{
            modalReview.classList.remove('show')
            HtmlElem.classList.remove('menu__open')
        })
    }

    //модальное окно политики конфиденциальности
    let politicButtons = document.querySelectorAll('.privacy-link')
    let modalPolitic = document.querySelector('.modal__politic')
    let politicClose = document.querySelector('.modal-politic__close')

    politicButtons.forEach((elem)=>{
        elem.addEventListener('click',(e)=>{
            e.preventDefault()
            modalPolitic.classList.add('show')
            HtmlElem.classList.add('menu__open')
        })
    })
    politicClose.addEventListener('click',()=>{
        modalPolitic.classList.remove('show')
        HtmlElem.classList.remove('menu__open')
    })

    //модальное окно оферты
    let offerButtons = document.querySelectorAll('.offer-link')
    let modalOffer = document.querySelector('.modal__offer')
    let offerClose = document.querySelector('.modal-offer__close')
    let offerInput = document.querySelector('.modal-offer__input')

    if (modalOffer !== null){
        offerButtons.forEach((elem)=>{
            elem.addEventListener('click',(e)=>{
                e.preventDefault()
                modalOffer.classList.add('show')
                HtmlElem.classList.add('menu__open')
            })
        })
        offerClose.addEventListener('click',()=>{
            modalOffer.classList.remove('show')
            HtmlElem.classList.remove('menu__open')
        })
        offerInput.addEventListener('focus',()=>{
            if (!offerInput.checked) {
                modalOffer.classList.remove('show')
                HtmlElem.classList.remove('menu__open')
            }
        })
    }

    //Модальное окно видео
    let modalVideo = document.querySelector('.modal__video')
    let modalVideoButtonsArr = Array.from(document.querySelectorAll('.corridor-header__video-button'))
    let modalVideoClose = document.querySelector('.modal-video__close')
    if (modalVideoButtonsArr.length !== 0){
        modalVideoButtonsArr.forEach((elem)=>{
            elem.addEventListener('click',(e)=>{
                modalVideo.classList.add('show')
                HtmlElem.classList.add('menu__open')
            })
        })

        modalVideoClose.addEventListener('click',()=>{
            modalVideo.classList.remove('show')
            HtmlElem.classList.remove('menu__open')
        })
    }

    //Парралакс эффект
    let booksHeaderParallaxElem = document.getElementById('booksHeaderParallax')
    if (booksHeaderParallaxElem !== null){
        let booksHeaderParallax = new Parallax(booksHeaderParallaxElem,{
            relativeInput:true
        })
    }

    let corridorHeaderParallaxElem = document.getElementById('corridorParallaxElem')

    if (corridorHeaderParallaxElem !== null){
        let corridorHeaderParallax = new Parallax(corridorHeaderParallaxElem,{
            relativeInput:true
        })
    }


    //3d карточка
    VanillaTilt.init(document.querySelector("#booksPresentationParallax"), {
        max: 25,
        speed: 400
    });

    let scroll = new SmoothScroll('a[href*="#"]',{
        speed: 1000,
        easing: 'easeInOutCubic',
    });

    //Поблочная пагинация
    function renderBlockPagination(blockArr){
        let blockPagination = document.createElement('div')
        blockPagination.classList.add('block-pagination')

        for (let i = 0; i < blockArr.length; i++){
            let blockElem = blockArr[i]
            let activeColorClass = blockElem.dataset.bulletColor
            let blockId = blockElem.id
            let paginationBullet = renderBullet(blockId, activeColorClass)
            blockPagination.insertAdjacentHTML('beforeend',paginationBullet)
        };

        return blockPagination
    };


    function renderBullet(blockId,activeColorClass){
        return `<a class="block-pagination__link" href="#${blockId}"><span class="block-pagination__bullet ${activeColorClass}"></span></a>`
    };


    function setBlockObserve(blockArr,paginationBulletArr){
        let options = {
            threshold: .5,
            rootMargin: '0px',
        }

        function callback(entries,observer){
            entries.forEach((entry) =>{
                if (entry.isIntersecting){
                    let block = entry.target
                    let index = blockArr.indexOf(block)
                    paginationBulletArr.forEach((paginationBullet, i)=>{
                        if (i === index){
                            paginationBullet.classList.add('active')
                        }
                        else{
                            paginationBullet.classList.remove('active')
                        }
                    })
                }
            })
        }

        let observer = new IntersectionObserver(callback, options)
        blockArr.forEach(block => {observer.observe(block)})
    }

    function initBlockPagination(){
        let blockArr = Array.from(document.querySelectorAll('.block'))

        if (blockArr.length !== 0){

            let blockPagination = renderBlockPagination(blockArr)
            document.querySelector('body').insertAdjacentElement('beforeend', blockPagination)
            blockPagination.style.marginTop = '-' + blockPagination.offsetHeight / 2 + 'px'
            let paginationBulletArr = Array.from(document.querySelectorAll('.block-pagination__bullet'))
            setBlockObserve(blockArr, paginationBulletArr)

        }else{
            return
        }

    };

    initBlockPagination()



//Кастомизация карты
    let map;
    let clubMap;
    const loader = new Loader({
        apiKey: "AIzaSyAjH0AkDXBLarU0F6DozYfogBB93fgBbc4",
        version: "weekly",

    });

    loader.load().then(() => {
        let mapElem = document.getElementById("map")
        if (mapElem !== null){
            map = new google.maps.Map(mapElem, {
                center: { lat: 59.933543, lng: 30.341028 },
                zoom: 14,
                disableDefaultUI: true,
                gestureHandling: 'none',
                styles: [{featureType:"all",elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#000000"},{lightness:40}]},{featureType:"all",elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#000000"},{lightness:16}]},{featureType:"all",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#000000"},{lightness:20}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#000000"},{lightness:17},{weight:1.2}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#000000"},{lightness:20}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#000000"},{lightness:21}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#000000"},{lightness:17}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#000000"},{lightness:29},{weight:.2}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#000000"},{lightness:18}]},{featureType:"road.local",elementType:"geometry",stylers:[{color:"#000000"},{lightness:16}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#000000"},{lightness:19}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#000000"},{lightness:17}]}]
            });
        }
        let clubMapElem = document.getElementById("clubMap")

        if (clubMapElem !== null){
            clubMap = new google.maps.Map(clubMapElem,{
                center: {
                    lat: 51.515419,
                    lng: -.141099
                },
                zoom: 3,
                disableDefaultUI: !0,
                styles: [{
                    featureType: "administrative",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#444444"
                    }]
                }, {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [{
                        color: "#f2f2f2"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    featureType: "road",
                    elementType: "all",
                    stylers: [{
                        saturation: -100
                    }, {
                        lightness: 45
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "all",
                    stylers: [{
                        visibility: "simplified"
                    }]
                }, {
                    featureType: "road.arterial",
                    elementType: "labels.icon",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    featureType: "transit",
                    elementType: "all",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    featureType: "water",
                    elementType: "all",
                    stylers: [{
                        color: "#3E3E3E"
                    }, {
                        visibility: "on"
                    }]
                }]
            });
            let markers = [];
            [{
                name: "Англия",
                quantity: 4,
                latlng: [52.3555177, -1.1743197000000691]
            }, {
                name: "Австралия",
                quantity: 1,
                latlng: [-25.274398, 133.77513599999997]
            }, {
                name: "Аргентина",
                quantity: 1,
                latlng: [-38.416097, -63.616671999999994]
            },
                {
                    name: "Буларусь",
                    quantity: 57,
                    latlng: [53.709807, 27.953389000000016]
                },
                {
                    name: "Болгария",
                    quantity: 1,
                    latlng: [42.733883, 25.485829999999964]
                },
                {
                    name: "Германия",
                    quantity: 37,
                    latlng: [51.165691, 10.451526000000058]
                },
                {
                    name: "Греция",
                    quantity: 1,
                    latlng: [39.074208, 21.824311999999964]
                },
                {
                    name: "Египет",
                    quantity: 1,
                    latlng: [26.820553, 30.802498000000014]
                },
                {
                    name: "Израиль",
                    quantity: 4,
                    latlng: [31.046051, 34.85161199999993]
                },
                {
                    name: "Индонезия",
                    quantity: 3,
                    latlng: [-.789275, 113.92132700000002]
                },
                {
                    name: "Ирландия",
                    quantity: 1,
                    latlng: [53.41291, -8.243889999999965]
                },
                {
                    name: "Исладния",
                    quantity: 1,
                    latlng: [64.963051, -19.020835000000034]
                },
                {
                    name: "Испания",
                    quantity: 1,
                    latlng: [40.46366700000001, -3.7492200000000366]
                },
                {
                    name: "Италия",
                    quantity: 6,
                    latlng: [41.87194, 12.567379999999957]
                },
                {
                    name: "Казахстан",
                    quantity: 41,
                    latlng: [48.019573, 66.92368399999998]
                },
                {
                    name: "Канада",
                    quantity: 6,
                    latlng: [56.130366, -106.34677099999999]
                },
                {
                    name: "Кипр",
                    quantity: 1,
                    latlng: [35.126413, 33.429858999999965]
                },
                {
                    name: "Китай",
                    quantity: 8,
                    latlng: [35.86166, 104.19539699999996]
                },
                {
                    name: "Крым",
                    quantity: 21,
                    latlng: [45.3453029, 34.49972739999998]
                },
                {
                    name: "Латвия",
                    quantity: 9,
                    latlng: [56.879635, 24.60318899999993]
                },
                {
                    name: "Ливан",
                    quantity: 1,
                    latlng: [33.854721, 35.86228499999993]
                },
                {
                    name: "Литва",
                    quantity: 7,
                    latlng: [55.169438, 23.88127499999996]
                },
                {
                    name: "Люксембург",
                    quantity: 1,
                    latlng: [49.815273, 6.129583000000025]
                },
                {
                    name: "Молдавия",
                    quantity: 10,
                    latlng: [47.411631, 28.369885000000068]
                },
                {
                    name: "Нидерланды",
                    quantity: 3,
                    latlng: [52.132633, 5.2912659999999505]
                },
                {
                    name: "Новая Зеландия",
                    quantity: 1,
                    latlng: [-40.900557, 174.88597100000004]
                },
                {
                    name: "Норвегия",
                    quantity: 1,
                    latlng: [60.47202399999999, 8.46894599999996]
                },
                {
                    name: "ОАЭ",
                    quantity: 2,
                    latlng: [23.424076, 53.84781799999996]
                },
                {
                    name: "Польша",
                    quantity: 8,
                    latlng: [51.919438, 19.14513598999999]
                },
                {
                    name: "Россия",
                    quantity: 1201,
                    latlng: [61.52401, 105.31875600000001]
                },
                {
                    name: "Румыния",
                    quantity: 2,
                    latlng: [45.943161, 24.966760000000022]
                },
                {
                    name: "Сингапур",
                    quantity: 1,
                    latlng: [1.352083, 103.81983600000001]
                },
                {
                    name: "США",
                    quantity: 20,
                    latlng: [37.09024, -95.71289100000001]
                },
                {
                    name: "Таджикистан",
                    quantity: 1,
                    latlng: [38.861034, 71.27609299999995]
                },
                {
                    name: "Таиланд",
                    quantity: 4,
                    latlng: [15.870032, 100.99254100000007]
                },
                {
                    name: "Турция",
                    quantity: 1,
                    latlng: [38.963745, 35.243322000000035]
                },
                {
                    name: "Узбекистан",
                    quantity: 3,
                    latlng: [41.377491, 64.58526200000006]
                },
                {
                    name: "Украина",
                    quantity: 131,
                    latlng: [48.379433, 31.16557990000001]
                },
                {
                    name: "Филиппинны",
                    quantity: 3,
                    latlng: [12.879721, 121.77401699999996]
                },
                {
                    name: "Финляндия",
                    quantity: 1,
                    latlng: [61.92410999999999, 25.748151099999973]
                },
                {
                    name: "Франция",
                    quantity: 3,
                    latlng: [46.227638, 2.213749000000007]
                }, {
                name: "Чехия",
                quantity: 4,
                latlng: [49.81749199999999, 15.472962000000052]
                },
                {
                    name: "Швейцария",
                    quantity: 5,
                    latlng: [46.818188, 8.227511999999933]
                },
                {
                    name: "Швеция",
                    quantity: 3,
                    latlng: [60.12816100000001, 18.643501000000015]
                },
                {
                    name: "Эстония",
                    quantity: 6,
                    latlng: [58.595272, 25.013607099999945]
                },
                {
                    name: "Япония",
                    quantity: 2,
                    latlng: [36.204824, 138.252924]}]
                .forEach(function(element) {
                for (let i = 0; i < element.quantity; i++) {
                    let latLng = new google.maps.LatLng(element.latlng[0],element.latlng[1])
                        , marker = new google.maps.Marker({
                        position: latLng,
                        icon: {
                            url: "icons/map-mark_small.svg"
                        },
                        label: {
                            color: "white",
                            fontFamily: "Roboto, sans-serif",
                            fontWeight: "400",
                            fontSize: "12px",
                            text: "1",

                        },
                        optimized: !1,
                        visible: !0
                    });
                    markers.push(marker)
                }
            })
            let markerCluster = new MarkerClusterer(clubMap,markers,{
                styles: [{
                    url: "icons/map-mark.svg",
                    width: 50,
                    height: 50,
                    fontFamily: "Roboto, sans-serif",
                    fontWeight: "400",
                    textSize: "12",
                    textColor: "white",
                }],
            })
        }
    });
})